// extracted by mini-css-extract-plugin
export default {"join":"JoinScreen_join__vKQsq","box":"JoinScreen_box__O4vGw"};